import {SimplePage} from "../../elements/Pages";
import React, {useEffect, useState} from "react";
import ListViewTable from "../../elements/tables/ListViewTable";
import {DownloadButton} from "../../elements/Buttons";
import {useSchoolYears} from "../../../contexts/SchoolYearContext";
import SchoolYearFilter from "../../elements/SchoolYearFilter";
import {
    getMissingHomeworkOrMaterialsByTeacherReport,
    getMissingHomeworkOrMaterialsByTeacherReportExcel
} from "../../../api/reports";
import {useQuery} from "@tanstack/react-query";


const columns = [
    {
        accessorFn: (row) => `${row.last_name}, ${row.first_name}`,
        id: "staff",
        header: "LehrerIn",
        hide: false,
        enableColumnFilter: false,
    },
    {
        accessorKey: "missing_homework_students",
        id: "missing_homework",
        header: "Fehl. HA",
        enableColumnFilter: false
    },
    {
        accessorKey: "missing_materials_students",
        id: "missing_materials",
        header: "Fehl. Mat.",
        enableColumnFilter: false
    }
]

export default function MissingHomeworkAndMaterialsByTeacherReport() {

    const {schoolYears, currentSchoolYear} = useSchoolYears();
    const [schoolYearId, setSchoolYearId] = useState();

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["missing_homework_or_materials_by_teacher", schoolYearId],
        () => getMissingHomeworkOrMaterialsByTeacherReport(schoolYearId),
        {
            enabled: !!schoolYearId, refetchInterval: 1000 * 60 * 60
        }
    )


    useEffect(() => {
        if (currentSchoolYear) setSchoolYearId(currentSchoolYear["id"]);
    }, [currentSchoolYear])

    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Fehlende Hausaufgaben/Materialien nach Lehrern
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <DownloadButton
                            apiFunction={() => getMissingHomeworkOrMaterialsByTeacherReportExcel(schoolYearId)}
                            fileName="Fehl. HA/Mat nach Lehrern.xls"
                            label="Excel herunterladen"/>

                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            <SchoolYearFilter
                                schoolYears={schoolYears}
                                schoolYearId={schoolYearId}
                                setSchoolYearId={setSchoolYearId}
                            />
                        </div>

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={false}
                                    disableGlobalSearch={false}
                                    getRowLink={null}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
